import { GlobalManualAdjustmentsManager } from "src/modules/GlobalManualAdjustmentsManager/GlobalManualAdjustmentsManager";

export const GlobalManualAdjustmentsPage: React.FC = () => {
  return <GlobalManualAdjustmentsManager />;
};
